import * as types from "../Actions/Types";
import { IBuxtonSupportTeamMember } from "../Models/Models";

export interface ICompanySupportTeamState {
  companySupportTeam: Array<IBuxtonSupportTeamMember>;
}

const defaultState: ICompanySupportTeamState = {
    companySupportTeam: [],
};

export const companySupportTeamStore = (
    store: ICompanySupportTeamState = { ...defaultState },
    action
) => {
    switch (action.type) {
        case types.GET_COMPANY_SUPPORT_TEAM_SUCCESS:
            return Object.assign({}, store, {
                companySupportTeam: action.data || [],
            });

            // FAILURE
        case types.GET_COMPANY_SUPPORT_TEAM_FAILURE:
            console.log(action);

        default:
            return store;
    }
};
